import classNames from "classnames";

import { TeamID } from "../../../types";
import { HeaderBreadCrumbs } from "../../HeaderBreadCrumbs/HeaderBreadCrumbs";

import style from "./FloatingBreadcrumbs.module.css";

interface FloatingBreadcrumbsProps {
  teamId: TeamID;
  spaceName: string;
  isOpen?: boolean;
}
export const FloatingBreadcrumbs = ({ teamId, spaceName, isOpen }: FloatingBreadcrumbsProps) => {
  return (
    <div className={classNames(style.floatingBreadcrumbs, { [style.closed]: !isOpen })}>
      <HeaderBreadCrumbs teamID={teamId} spaceName={spaceName} />
    </div>
  );
};
